<template>
  <div class="flex-container">
    <PageTop title="Ürün Ekle" />
    <div class="main-area">
      <div class="template-manager" v-if="!loading">
        <TemplateManager
          :action="action"
          :index="index"
          v-for="(action, index) in templateActions"
          v-bind:key="index"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import PageTop from "@/components/Page/PageTop.vue";
import TemplateManager from "@/components/TemplateManager/TemplateManager";
import { computed } from "vue";
import {
  ADD_BULK_TEXTS,
  ADD_SINGLE_TEXTS,
  ADD_CATALOG_TEXTS,
} from "@/utils/enum/createProductActions";
import {
  // NEW_PRODUCT_LISTING_SHOW_ENABLE,
  NEW_PRODUCT_CREATE_DESIGN_ENABLE,
  NEW_PRODUCT_CREATE_SINGLE_SHOW_ENABLE,
  NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE,
} from "@/utils/enum/configs";
import { useStore } from "vuex";

const store = useStore();

// const isNewProductListingEnabled = computed(
//   () => store.getters["common/getConfigList"][NEW_PRODUCT_LISTING_SHOW_ENABLE]
// );
const isNewProductCreateDesignEnabled = computed(
  () => store.getters["common/getConfigList"][NEW_PRODUCT_CREATE_DESIGN_ENABLE]
);
const isNewProductCreateSingleShowEnabled = computed(
  () =>
    store.getters["common/getConfigList"][NEW_PRODUCT_CREATE_SINGLE_SHOW_ENABLE]
);
const isNewBulkProductManagementDesignEnabled = computed(
  () =>
    store.getters["common/getConfigList"][
      NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE
    ]
);

const templateActions = computed(() => {
  return [
    {
      ...ADD_CATALOG_TEXTS,
      ctaAction: () =>
        window.open(
          isNewProductCreateDesignEnabled.value === "true"
            ? "/selleroffice/v2/product/create/catalog"
            : "/selleroffice/product/createProduct",
          "_self"
        ),
      errors: {},
    },
    {
      ...ADD_SINGLE_TEXTS,
      ctaAction: () => {
        localStorage.removeItem('variantTemplateData');
        window.open(
          isNewProductCreateSingleShowEnabled.value === "true"
            ? "/selleroffice/v2/product/create/single"
            : "/selleroffice/product/createProduct",
          "_self"
        );
      },
      errors: {},
    },
    {
      ...ADD_BULK_TEXTS,
      ctaAction: () =>
        window.open(
          isNewBulkProductManagementDesignEnabled.value === "true"
            ? "/selleroffice/v2/product/create/bulk"
            : "/selleroffice/integration/main",
          "_self"
        ),
      errors: {},
    },
  ];
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.flex-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 24px;

  .loading {
    aspect-ratio: 1183/518;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seperator {
    margin: 16px 0;
    height: 0.5px;
    width: 100%;
    background-color: $colorD30;
  }

  .main-area {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: $colorN00;
    padding-bottom: 24px;
    border-radius: 8px;
  }

  .filter-area-top {
    gap: 16px;
    display: flex;
    justify-content: space-between;
    background: $colorN00;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    &.header-tab {
      padding: 24px 24px 0px;
    }
    .watch-link {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 42px;
      border-radius: 6px;
      padding: 12px 24px;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.05px;
      border: 0.5px solid #b3bbcb;

      img {
        margin-right: 4px;
      }
    }
    .periods {
      display: flex;
      gap: 12px;

      .tab {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 166px;
        height: 42px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.05px;
        border: 0.5px solid $colorD30;

        &.table-tabs {
          width: 190px;
          padding: 0 12px;
          font-size: 13px;
        }
        &.selected {
          font-weight: 700;
          color: $colorM50;
          background: $colorM05;
          border: 2px solid $colorM50;
        }
      }
    }
  }

  .list-area {
    border-radius: 8px;
    padding: 0 24px;
  }
}

.tab.disabled {
  border: none;
  background-color: #b3bbcb;
  color: #f5f5f5;
  cursor: not-allowed;
  pointer-events: none;
}

.info-box-wrapper {
  padding: 0 24px;
  .info-box {
    display: flex;
    background-color: $colorB10;
    padding: 16px;
    margin-bottom: 16px;
    gap: 12px;
    border-radius: 6px;

    &-container {
      display: flex;
      width: 100%;
      font-size: 13px;
      justify-content: space-between;

      span {
        font-weight: 700;
      }
      p {
        margin-top: 4px;
      }
    }

    .btn-container {
      display: flex;
      gap: 24px;
    }

    .dismiss-info-box {
      padding: 4px;
      color: #8aadd7;
      font-size: 24px;
      width: 32px;
      text-align: center;
    }
  }
}

.template-manager {
  display: flex;
  gap: 24px;
  padding: 40px 24px 16px 24px;
}

.box {
  background: $colorN00;
  width: 100%;
}

.categories-modal {
  .category-tree {
    max-height: 400px;
    overflow: hidden;
    display: flex;
    margin-top: 24px;
    border-radius: 6px;
    > div {
      background-color: white;
      border: 1px solid $colorD30;
      width: 249px;
      overflow-y: scroll;

      &:first-child {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }

      &:last-child {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
      &:not(:first-child) {
        border-left: none;
      }
    }

    &-item {
      display: flex;
      font-size: 12px;
      font-style: normal;
      line-height: 16px;
      font-weight: 400;
      padding: 6px 12px;
      border-top: 1px solid $colorD30;
      align-items: center;
      height: 40px;
      justify-content: space-between;
      text-align: left;
      &-leaf {
        svg {
          width: 18px;
          height: 18px;
        }
      }

      &.selected {
        background-color: $colorM05;
        color: $colorM50 !important;
        font-weight: 700;
        div {
          color: $colorM50 !important;
          svg {
            color: $colorM50 !important;
          }
        }
        .category-tree-item-leaf {
          div {
            color: $colorM50 !important;
            svg {
              color: $colorM50 !important;
            }
          }
        }
      }
      &.parent {
        font-weight: bold;
        svg {
          color: $colorD40;
        }
        div {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }
      &-image {
        width: 28px;
        height: 28px;
      }

      &.group-name {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        padding: 10px 12px;
        border-top: none;
        line-height: 20px;
        position: sticky;
        top: 0;
        background-color: $colorN00;
        z-index: 1;
        border-bottom: 1px solid $colorD30;
      }
    }
  }
  .group-categories {
    display: flex;
    gap: 12px;
    margin-top: 24px;
    > div {
      &:first-child {
        display: none;
      }
    }
    &-item {
      padding: 12px;
      min-height: 172px;
      background-color: $colorN00;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      span {
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
      }

      img {
        width: 104px;
        height: 104px;
      }
    }
  }
  &-title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
    text-align: left;
    color: $colorN80;
  }

  &-desc {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    margin-top: 8px;
    color: $colorN80;
  }

  &-content {
    padding: 16px;
    background-color: $colorD10;
    margin-top: 24px;
    border-radius: 6px;

    h3 {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      text-align: left;
      margin-bottom: 12px;
    }
  }

  .search-field-result-box {
    width: 640px;
    height: 340px;
    overflow-y: scroll;
    background-color: $colorN00;
    border-radius: 6px;
    border: 1px solid $colorD40;
    box-shadow: 0px 0px 0px 3px #d3d6df;
    position: absolute;
    z-index: 2;

    &-item {
      padding: 10px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 0.5px solid $colorD30;
      color: $colorN80;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      &:hover {
        background-color: $colorM05;
      }
    }
    .item-details {
      text-align: left;
    }
  }

  .active-button {
    background-color: $colorM50 !important;
    color: $colorN00 !important;
    cursor: not-allowed;
  }
  .download-icon {
    color: $colorM50 !important;
  }

  .download-icon.icon-active {
    color: $colorN00 !important;
  }
}
</style>
